import { ContactRound, School, ScrollText, User, Users } from "lucide-react"

import type { WorkspaceDefinition } from "@/components/workspace/definition"
import {
  editLearnersSchoolSchoolProfile,
  learnersSchoolPreferenceTemplates,
  learnersSchoolReliefListings,
  learnersSchoolStudents,
  learnersSchoolWorkspace,
} from "@/routes"

// A school's workspace, held by its administrators: its home page, its
// destinations in the order the workspace page and the role menu list them,
// and the role's mark in the header. The owner id is the school's.
export const schoolAdminWorkspace: WorkspaceDefinition = {
  ownerType: "school_admin",
  root: (schoolId) => learnersSchoolWorkspace({ schoolId }).url,
  destinations: [
    {
      key: "profile",
      href: (schoolId) => editLearnersSchoolSchoolProfile({ schoolId }).url,
      titleKey: "school_workspace:links.profile",
      descriptionKey: "school_workspace:links.profile_description",
      icon: User,
    },
    {
      key: "students",
      href: (schoolId) => learnersSchoolStudents.index({ schoolId }).url,
      titleKey: "school_workspace:links.students",
      descriptionKey: "school_workspace:links.students_description",
      icon: Users,
    },
    {
      key: "preferences",
      href: (schoolId) => learnersSchoolPreferenceTemplates({ schoolId }).url,
      titleKey: "school_workspace:links.preferences",
      descriptionKey: "school_workspace:links.preferences_description",
      icon: ScrollText,
    },
    {
      key: "relief_listings",
      href: (schoolId) => learnersSchoolReliefListings({ schoolId }).url,
      titleKey: "school_workspace:links.relief_listings",
      descriptionKey: "school_workspace:links.relief_listings_description",
      icon: ContactRound,
    },
  ],
  namespaces: ["school_workspace"],
  icon: School,
  tint: "bg-brand-light-philo-mustard",
}
